import { render, staticRenderFns } from "./qcContribute.vue?vue&type=template&id=2b2186f8&scoped=true"
import script from "./qcContribute.vue?vue&type=script&lang=js"
export * from "./qcContribute.vue?vue&type=script&lang=js"
import style0 from "./qcContribute.vue?vue&type=style&index=0&id=2b2186f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2186f8",
  null
  
)

export default component.exports